<script setup lang="ts">
import { AppSelectSearchable } from '@shared/ui/selects'

import { useDisciplineTutorSelect } from '../model/discipline-tutor-select.hook'

defineOptions({
  name: 'DisciplineTutorSelect',
})

withDefaults(defineProps<{
  label?: string
  placeholder?: string
  disabled?: boolean
  clearable?: boolean
}>(), {
  label: 'Tutor:',
  placeholder: 'Select tutor',
  disabled: false,
  clearable: false,
})

const model = defineModel<number | null>({ default: null })

const {
  refTutorId,
  tutorOptions,
  selectedTutorOption,
  tutorHasMore,
  tutorLoading,
  onTutorSearch,
  onTutorLoadMore,
  onTutorOpen,
} = useDisciplineTutorSelect({ tutorId: model })
</script>

<template>
  <AppSelectSearchable
    v-model="refTutorId"
    :options="tutorOptions"
    :selected-option="selectedTutorOption"
    :has-more="tutorHasMore"
    :loading="tutorLoading"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    infinite
    @search="onTutorSearch"
    @load-more="onTutorLoadMore"
    @open="onTutorOpen"
  />
</template>
